module.exports = __webpack_public_path__ + "media/Security_Breach_Alarm_Siren.513197dd.wav";